export enum ResponseStatus {
  SUCCESS = 'Success',
  ERROR = 'Error',
}
